module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fabricante/fabricante.component.css
// module id = ./src/app/fabricante/fabricante.component.css
// module chunks = main